import { nanoid } from 'nanoid';

export const generateUserId = () => {
  return nanoid(); // génère un ID unique de type : "V1StGXR8_Z5jdHi6B-myT"
};
